import { onBeforeUnmount, ref, type Ref } from 'vue';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

interface UseBreakpointsResult {
  current: Ref<Breakpoint>;
}

export function useBreakpoints(): UseBreakpointsResult {
  const current = ref<Breakpoint>('mobile');

  if (typeof window === 'undefined') {
    return { current };
  }

  const mqTablet = window.matchMedia('(min-width: 768px)');
  const mqDesktop = window.matchMedia('(min-width: 1024px)');

  function update(): void {
    if (mqDesktop.matches) current.value = 'desktop';
    else if (mqTablet.matches) current.value = 'tablet';
    else current.value = 'mobile';
  }

  update();
  mqTablet.addEventListener('change', update);
  mqDesktop.addEventListener('change', update);

  onBeforeUnmount(() => {
    mqTablet.removeEventListener('change', update);
    mqDesktop.removeEventListener('change', update);
  });

  return { current };
}
